import { styled, TextField } from "@mui/material";

export const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor:
      theme.palette.mode === "dark" ? "#252528" : "#FAFBFD",
    ...(theme.palette.mode === "dark" ? { color: "#f5f5f5" } : {}),
    borderRadius: "8px !important",
    "& fieldset": {
      borderColor:
        theme.palette.mode === "dark"
          ? "#3a3a3e"
          : theme.palette.grey[300],
      borderWidth: "1px",
      BorderStyle: "solid",
      borderRadius: "8px !important",
    },
    "&:hover fieldset": {
      borderColor:
        theme.palette.mode === "dark"
          ? "#5a5a5e"
          : theme.palette.grey[500],
      borderWidth: "1px",
      BorderStyle: "solid",
      borderRadius: "8px !important",
    },
    "&.Mui-focused fieldset": {
      borderWidth: "2px",
      borderColor: theme.palette.primary.main,
      borderRadius: "8px !important",
    },
  },
}));
